import { ErrorPageComponent } from './error-page/error-page.component';
import { LinktoComponent } from './linkto/linkto.component';
import { SharedCarModule } from './shared/shared-car.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlternativeCurrenciesService } from './shared/alternative-currencies.service';
import { AcrisCarCodesService } from './shared/acriss-car-codes.service';
import { MapVisibilityService } from './shared/map-visibility.service';
import { CountryService } from './shared/country.service';
import { TimeService } from './shared/time.service';
import { DictionaryService } from './shared/dictionary.service';
import { CarOptionsShortModule } from './shared/car-options-short/car-options-short.module';
import { CarOptionsModule } from './shared/car-options/car-options.module';
import { SharedModule } from '../shared/shared.module';
import { CarComponent } from './car.component';
import { FooterComponent } from './footer/footer.component';
import { SharedSearchResultsService } from './shared/shared-search-results.service';
import { HeaderModule } from './header/header.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    BrowserAnimationsModule,
    SharedCarModule,
    MatGridListModule,
    MatListModule,
    MatDialogModule,
    MatIconModule,
    FormsModule,
    CarOptionsShortModule,
    CarOptionsModule,
    HeaderModule,
  ],
  exports: [
    CarComponent
  ],
  declarations: [
    CarComponent,
    FooterComponent,
    LinktoComponent,
    ErrorPageComponent
  ],
  providers: [
    AlternativeCurrenciesService,
    AcrisCarCodesService,
    CountryService,
    SharedSearchResultsService,
    TimeService,
    DictionaryService,
    MapVisibilityService
  ]
})

export class CarModule { }
